import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, Subscription } from 'rxjs';
import { GetProjectIdService } from '../getProjectId.service';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class RfiService {
  private apiUrl = environment.apiUrl;
  private subscription: Subscription = new Subscription();
  constructor(
    private http: HttpClient,
    private getProjectIdService: GetProjectIdService
  ) {}

  private loadProjectTypeDataSubject = new Subject<void>();
  loadProjectTypeData$ = this.loadProjectTypeDataSubject.asObservable();
  loadProjectTypeData() {
    this.loadProjectTypeDataSubject.next();
  }

  /**
   * ####################################
   * CONTRACTOR START
   * ####################################
   */
  // get list of rfi's
  getRfiList(orgId: number): Observable<any> {
    let projectId: any;
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      projectId = id;
      if (!projectId) {
        projectId = this.getProjectIdService.getProjectId();
      }
    });

    return this.http.get(
      `${this.apiUrl}/projects/${projectId}/rfi/listing/${orgId}`
    );
  }

  // get list of rfi's
  getClientRfiList(): Observable<any> {
    let projectId: any;
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      projectId = id;
      if (!projectId) {
        projectId = this.getProjectIdService.getProjectId();
      }
    });

    return this.http.get(`${this.apiUrl}/projects/${projectId}/rfi`);
  }

  // get RFI comments
  getRfiComments(rfiId: number): Observable<any> {
    let projectId: any;
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      projectId = id;
      if (!projectId) {
        projectId = this.getProjectIdService.getProjectId();
      }
    });

    return this.http.get(
      `${this.apiUrl}/projects/${projectId}/rfi/${rfiId}/comments`
    );
  }

  // add RFI comment
  addRfiComment(data: any, rfiId: number): Observable<any> {
    let projectId: any;
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      projectId = id;
      if (!projectId) {
        projectId = this.getProjectIdService.getProjectId();
      }
    });

    return this.http.post(
      `${this.apiUrl}/projects/${projectId}/rfi/${rfiId}/store`,
      data
    );
  }
  // delete RFI comment
  deleteRfiComment(rfiId: number, commentId: number): Observable<any> {
    let projectId: any;
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      projectId = id;
      if (!projectId) {
        projectId = this.getProjectIdService.getProjectId();
      }
    });

    return this.http.delete(
      `${this.apiUrl}/projects/${projectId}/rfi/${rfiId}/comment/${commentId}`
    );
  }
  // update RFI comment
  updateRfiComment(
    data: any,
    rfiId: number,
    commentId: number
  ): Observable<any> {
    let projectId: any;
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      projectId = id;
      if (!projectId) {
        projectId = this.getProjectIdService.getProjectId();
      }
    });

    return this.http.put(
      `${this.apiUrl}/projects/${projectId}/rfi/${rfiId}/comment/${commentId}`,
      data
    );
  }
  // reply RFI comment
  replyRfiComment(
    data: any,
    rfiId: number,
    commentId: number
  ): Observable<any> {
    let projectId: any;
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      projectId = id;
      if (!projectId) {
        projectId = this.getProjectIdService.getProjectId();
      }
    });

    return this.http.post(
      `${this.apiUrl}/projects/${projectId}/rfi/${rfiId}/comment/${commentId}/store`,
      data
    );
  }

  createRfi(data): Observable<any> {
    let projectId: any;
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      projectId = id;
      if (!projectId) {
        projectId = this.getProjectIdService.getProjectId();
      }
    });

    return this.http.post(
      `${this.apiUrl}/projects/${projectId}/rfi/create`,
      data
    );
  }
  submitRfiResponse(data, rfiId: number): Observable<any> {
    let projectId: any;
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      projectId = id;
      if (!projectId) {
        projectId = this.getProjectIdService.getProjectId();
      }
    });

    return this.http.post(
      `${this.apiUrl}/projects/${projectId}/rfi/create/response/${rfiId}`,
      data
    );
  }
  updateRfiResponse(data, responseId: number): Observable<any> {
    let projectId: any;
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      projectId = id;
      if (!projectId) {
        projectId = this.getProjectIdService.getProjectId();
      }
    });
    return this.http.post(
      `${this.apiUrl}/projects/${projectId}/rfi/response/${responseId}/third-party`,
      data
    );
  }

  // get individual rfi info client side
  getRfiInfo(rfiId: number): Observable<any> {
    let projectId: any;
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      projectId = id;
      if (!projectId) {
        projectId = this.getProjectIdService.getProjectId();
      }
    });

    return this.http.get(`${this.apiUrl}/projects/${projectId}/rfi/${rfiId}`);
  }

  // get individual rfi info contractor side
  getContractorRfiInfo(rfiId: number): Observable<any> {
    let projectId: any;
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      projectId = id;
      if (!projectId) {
        projectId = this.getProjectIdService.getProjectId();
      }
    });

    return this.http.get(
      `${this.apiUrl}/projects/${projectId}/rfi/${rfiId}/approved/responses`
    );
  }

  // get individual rfi info
  approvedRfiResponse(data: any, responseId: number): Observable<any> {
    let projectId: any;
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      projectId = id;
      if (!projectId) {
        projectId = this.getProjectIdService.getProjectId();
      }
    });

    return this.http.put(
      `${this.apiUrl}/projects/${projectId}/rfi/store/response/status/${responseId}`,
      data
    );
  }

  // send to client
  sendToClient(rfiId: number): Observable<any> {
    let projectId: any;
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      projectId = id;
      if (!projectId) {
        projectId = this.getProjectIdService.getProjectId();
      }
    });

    return this.http.post(
      `${this.apiUrl}/projects/${projectId}/rfi/${rfiId}/submit`,
      {}
    );
  }

  // get list of rfi's
  getProjectAwardedData(): Observable<any> {
    let projectId: any;
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      projectId = id;
      if (!projectId) {
        projectId = this.getProjectIdService.getProjectId();
      }
    });

    return this.http.get(
      `${this.apiUrl}/projects/${projectId}/organization/contractors/awarded`
    );
  }

  /**
   * ####################################
   * CONTRACTOR END
   * ####################################
   */
}
